import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63787bde")

_pushScopeId("data-v-63787bde")
const _hoisted_1 = { class: "items-center" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "text-center py-2 pagination" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createBlock("div", {
    class: ["text-gray-333", {
      'fixed-header': $props.fixedHeader,
    }]
  }, [
    _createVNode("div", null, [
      _createVNode("table", {
        class: [$setup.classes, "w-full border overflow-auto"]
      }, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.headers, (item) => {
                return (_openBlock(), _createBlock("th", {
                  key: item.value,
                  style: {
                  width: item.width,
                  minWidth: item.width,
                  textAlign: item.align,
                  whiteSpace: item.whitespace,
                },
                  class: "truncate"
                }, [
                  ($props.showSelect && item.value === 'checkbox')
                    ? _renderSlot(_ctx.$slots, "header-checkbox", {
                        key: 0,
                        item: item
                      }, () => [
                        _createVNode("div", _hoisted_1, [
                          _createVNode("span", _hoisted_2, _toDisplayString(item.text), 1),
                          _createVNode(_component_Checkbox, {
                            classes: "justify-center",
                            onChange: $setup.onSelectedAll,
                            modelValue: $setup.isCheckAll,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.isCheckAll = $event))
                          }, null, 8, ["onChange", "modelValue"])
                        ])
                      ], true)
                    : (item.type === 'html')
                      ? (_openBlock(), _createBlock("div", {
                          key: 1,
                          innerHTML: item.text
                        }, null, 8, ["innerHTML"]))
                      : _renderSlot(_ctx.$slots, `header-` + item.value, {
                          key: 2,
                          item: item
                        }, () => [
                          _createTextVNode(_toDisplayString(item.text), 1)
                        ], true)
                ], 4))
              }), 128))
            ])
          ])
        ], {}, true),
        _renderSlot(_ctx.$slots, "body", {}, () => [
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.data, (item, index) => {
              return (_openBlock(), _createBlock("tr", {
                key: item.id
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.headers, (header) => {
                  return (_openBlock(), _createBlock("td", {
                    key: header.value,
                    style: {
                  background: header.background,
                  verticalAlign: header.verticalAlign,
                  textAlign: header.dataAlign,
                },
                    class: "break-all"
                  }, [
                    _renderSlot(_ctx.$slots, header.value, {
                      item: item,
                      index: index
                    }, () => [
                      (header.value === 'checkbox')
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 0,
                            classes: "justify-center",
                            value: item,
                            modelValue: $setup.selectedItemList,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.selectedItemList = $event)),
                            onChange: $setup.onSelected
                          }, null, 8, ["value", "modelValue", "onChange"]))
                        : (_openBlock(), _createBlock("div", {
                            key: 1,
                            class: [header.bodyClass]
                          }, _toDisplayString(item[header.value]), 3))
                    ], true)
                  ], 4))
                }), 128))
              ]))
            }), 128)),
            ($props.data.length === 0 && !$setup.isLoading)
              ? _renderSlot(_ctx.$slots, "no-data", { key: 0 }, () => [
                  _createVNode("tr", null, [
                    _createVNode("td", {
                      colspan: $props.headers.length,
                      class: "text-left text-red-ed"
                    }, _toDisplayString($setup.t('thereIsNoData')), 9, ["colspan"])
                  ])
                ], {}, true)
              : _createCommentVNode("", true)
          ])
        ], {}, true)
      ], 2)
    ]),
    ($props.showPagination && $props.currentPage && $props.recordTotal)
      ? _renderSlot(_ctx.$slots, "pagination", { key: 0 }, () => [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Pagination, {
              pageActive: $setup.pageActive,
              "onUpdate:pageActive": _cache[3] || (_cache[3] = ($event: any) => ($setup.pageActive = $event)),
              perPage: $setup.itemPerPagesValue,
              "onUpdate:perPage": _cache[4] || (_cache[4] = ($event: any) => ($setup.itemPerPagesValue = $event)),
              "show-item-per-page": $props.showItemPerPage,
              totalItem: $props.recordTotal,
              onChangePage: $setup.onChangePage
            }, null, 8, ["pageActive", "perPage", "show-item-per-page", "totalItem", "onChangePage"])
          ])
        ], {}, true)
      : _createCommentVNode("", true)
  ], 2))
})